import React from 'react';
import { useSelector } from 'react-redux';
import { ReactComponent as CalendarUnavailable } from '../static/img/calendar-unavailable.svg';
import './ConsultantBookingError.sass';

function ConsultantBookingPostBook1005() {
  return (
    <div className="consultant-error">
      <span>
        <CalendarUnavailable />
      </span>
      <div className="error-text">
        <h3>Sorry, this appointment is no longer available</h3>
        <p>
          Please refresh this page to view other available appointments with this consultant. You
          can also
          <a
            target="_blank"
            rel="noreferrer"
            href={`${process.env.REACT_APP_CMS_PUBLIC_URL}consultants`}
          >
            {' '}
            search to find a different consultant
          </a>
          .
        </p>
        <p>
          If you can’t find a suitable appointment, call <a href="tel:03001231995">0300 123 1995</a>{' '}
          and we’ll help with your booking.
        </p>
        <p>
          <em>
            The appointment you initially selected may appear as available, but it is not bookable.
            Please choose a different date or time.
          </em>
        </p>
      </div>
    </div>
  );
}

function GenericConsultantBookingError() {
  return (
    <div className="consultant-error">
      <span>
        <CalendarUnavailable />
      </span>
      <div className="error-text">
        <h3>Sorry, something has gone wrong</h3>
        <p>
          Please refresh the page or{' '}
          <a
            target="_blank"
            rel="noreferrer"
            href={`${process.env.REACT_APP_CMS_PUBLIC_URL}consultants`}
          >
            try again
          </a>
          . You can also call us on <a href="tel:03001231995">0300 123 1995</a> to continue your
          booking.
        </p>
      </div>
    </div>
  );
}

function deriveError(error) {
  const code = error?.error?.errorCode;
  const url = error?.requestUrl || '';
  const method = error?.requestMethod;

  if (code === 1005 && url.includes('/book') && method === 'POST') {
    return 'BOOK_POST_1005';
  }

  return 'GENERIC_CONSULTANT_BOOKING_ERROR';
}

const VIEW_REGISTRY = {
  BOOK_POST_1005: ConsultantBookingPostBook1005, // APAS error: [POST] /book -> 1005 errorCode from Integration Hub
  GENERIC_CONSULTANT_BOOKING_ERROR: GenericConsultantBookingError,
};

export default function ConsultantBookingError() {
  const error = useSelector(state => state.consultantBookingError);

  if (!error) return null;

  const errorKey = deriveError(error);
  const View = VIEW_REGISTRY[errorKey] || GenericConsultantBookingError;

  return <View error={error} />;
}
